/**
 * 한국어 dictionary — keys are the English source strings.
 * Station/stop names stay English for ko (stationMode "en").
 */
export const ko = {
  "(Hong Kong time, UTC+8). Live clock.": "（홍콩 시간, UTC+8）。실시간 시계。",
  "(Hong Kong time, UTC+8). Reset returns to live clock.": "（홍콩 시간, UTC+8）。초기화하면 실시간 시계로 돌아갑니다.",
  "(UTC+8). Reset returns to Now.": "（UTC+8）。초기화하면「지금」으로 돌아갑니다.",
  "(merged official stops + OSRM densify).": "（공식 정류장 병합 + OSRM 밀도화）。",
  "(orange). Official stop coords stay fixed (grey ghosts) for identity / merge.": "（주황색）。공식 정류장 좌표는 고정된 상태（회색 잔상）로 유지되어 정체성／병합을 보장합니다.",
  "*You might still need short station access if you disabled Walk. Plans to a stop/station itself stay listed.": "*보행을 꺼도 짧은 역 접근이 여전히 필요할 수 있습니다. 정류장·역 자체로의 경로는 계속 표시됩니다.",
  ", and": ", 그리고",
  ", you can load a calculated path and edit turning points for moderators to review.": ", 계산된 경로를 로드하고 회전점을 편집하여 중재자의 검토를 받을 수 있습니다.",
  "0 path pts": "경로점 0개",
  "@Bus": "@버스",
  "@LRT": "@경전철",
  "@MTR": "@MTR",
  "AEL": "에어포트 익스프레스",
  "About": "정보",
  "About Travelers": "Travelers 정보",
  "Add via": "경유 추가",
  "Airport Express (AEL)": "에어포트 익스프레스（AEL）",
  "Alight": "하차",
  "Alight match": "하차 매칭",
  "All done!": "모두 완료!",
  "All done! Let's start enjoying your trip with Travelers!": "모두 완료! Travelers와 함께 즐거운 여행을 시작하세요!",
  "All modes": "모든 교통수단",
  "All operators": "모든 운수사",
  "Allow location for origin, or set From manually": "출발지에 현재 위치를 허용하거나 출발지를 직접 설정하세요",
  "Also fetches ETAs at the nearest stops and every 5th stop ahead and behind the selected stop, so positions are stitched from more anchors (extra requests per route view).": "가장 가까운 정류장과 선택한 정류장 앞뒤로 5개 간격의 정류장에서도 ETA를 가져와 더 많은 기준점으로 위치를 보간합니다（노선 보기마다 요청이 늘어남）。",
  "App opens the PR with the site bot token (no GitHub login).": "앱이 사이트 봇 토큰으로 PR을 엽니다（GitHub 로그인 불필요）。",
  "App sections": "앱 섹션",
  "Application code © UNLOOP MORGAN 2026. Apache 2.0 does not grant trademark rights. “MORGAN”, “Travelers”, logos, and product naming may not be reused without permission.": "앱 코드 © UNLOOP MORGAN 2026. Apache 2.0은 상표권을 부여하지 않습니다. 「MORGAN」, 「Travelers」, 로고, 제품명은 허가 없이 재사용할 수 없습니다.",
  "Auto-caches only the app shell (UI, fonts, icons) so ordinary use never burns mobile data. Fares, route/stop data and the basemap are downloaded only when you press “Download offline data” below (≈ 55 MB) — press the button again after updates to refresh it.": "앱 셸（UI, 글꼴, 아이콘）만 자동 캐시되므로 일상적인 사용에서 모바일 데이터를 소모하지 않습니다. 요금·노선／정류장 데이터와 베이스맵은 아래의「오프라인 데이터 다운로드」를 누를 때만 받아집니다（약 55 MB）— 업데이트 후에는 버튼을 다시 눌러 갱신하세요.",
  "Back": "뒤로",
  "Back online": "온라인 복귀",
  "Back to search": "검색으로 돌아가기",
  "Back to trip": "여정으로 돌아가기",
  "Balanced": "균형",
  "Basemap style and layer definitions (Protomaps).": "베이스맵 스타일과 레이어 정의（Protomaps）。",
  "Basemap tiles generated from OpenStreetMap (via hk-pmtiles-generation) and served from the Travelers data edge.": "베이스맵 타일은 OpenStreetMap（hk-pmtiles-generation 경유）에서 생성되어 Travelers 데이터 엣지에서 제공됩니다.",
  "Beta": "베타",
  "Beta Feature": "베타 기능",
  "Beta Features": "베타 기능",
  "Beta banner enabled": "베타 배너가 활성화되었습니다",
  "Beta banner hidden": "베타 배너가 숨겨졌습니다",
  "Beta features": "베타 기능",
  "Beta warning banner": "베타 안내 배너",
  "Board": "승차",
  "Board match": "승차 매칭",
  "Board/alight name fragments required (auto-filled after Load path).": "승차/하차 이름 조각이 필요합니다(경로 로드 후 자동 입력됨).",
  "Bot account": "봇 계정",
  "Box-select path points / offsets (B)": "박스 선택으로 경로점／오프셋 선택（B）",
  "Branch": "지선",
  "Build and toolchain": "빌드와 도구 체인",
  "Build tool (VoidZero Inc. and Vite contributors).": "빌드 도구（VoidZero Inc. 및 Vite 기여자）。",
  "Bus": "버스",
  "Bus · {cos}": "버스 · {cos}",
  "Bus / GMB routes, stops and fares (FARE, ROUTE, RSTOP, STOP tables) plus realtime ETAs (rt.data.gov.hk, data.etabus.gov.hk).": "버스／미니버스 노선·정류장·요금（FARE, ROUTE, RSTOP, STOP 테이블）및 실시간 ETA（rt.data.gov.hk, data.etabus.gov.hk）。",
  "Bus companies": "버스 회사",
  "Bus company": "버스 회사",
  "Bus paths are drawn live from the road network and can miss real alignments (e.g. Mei Tung Street vs the bus terminus). On": "버스 경로는 도로망에서 실시간으로 그려져 실제 노선과 다를 수 있습니다（예: 메이퉁 가 vs 버스 터미널）。켜짐",
  "Bus: route no. · MTR: line code (TWL, ISL, TCL…) · AEL · LRT: route no. (505) · GMB: route code (auto region search)": "버스: 노선 번호 · MTR: 선로 코드（TWL, ISL, TCL…）· AEL · 경전철: 노선 번호（505）· 미니버스: 노선 코드（자동 지역 검색）",
  "CTB": "시티버스",
  "Cache": "캐시",
  "Cache all data": "모든 데이터 캐시",
  "Cache data on device": "기기에 데이터 캐시",
  "Cache transit data on this device for offline use and mobile data savings.": "오프라인 사용과 모바일 데이터 절약을 위해 이 기기에 교통 데이터를 캐시합니다.",
  "Cache: checking…": "캐시: 확인 중…",
  "Cancel": "취소",
  "Cannot delete path endpoints": "경로 끝점은 삭제할 수 없습니다",
  "Change platforms": "승강장 변경",
  "Change platforms at {station}": "{station}에서 승강장 변경",
  "Check your connection and try again": "연결을 확인한 후 다시 시도하세요",
  "Checking edge metadata…": "엣지 메타데이터 확인 중…",
  "China T-Union Cards": "교통연합 카드",
  "Choose how to open a review PR on": "검토 PR을 여는 방식을 선택",
  "Choose operator + route →": "운수사 + 노선 선택 →",
  "Choose your default fare ticket type for trip plans.": "여정 계획에서 요금 계산에 사용할 기본 티켓 종류를 선택하세요.",
  "Choose your preferred language": "선호하는 언어를 선택하세요",
  "Circular": "순환",
  "Citybus": "시티버스",
  "Citybus (CTB)": "시티버스（CTB）",
  "Clear": "지우기",
  "Clear selection": "선택 지우기",
  "Clear via": "경유 지우기",
  "Click anywhere on the map for {field}": "지도의 아무 곳이나 클릭하여 {field} 설정",
  "Close": "닫기",
  "Cloud": "클라우드",
  "Cloud: live data first, downloaded copy as the offline fallback. Local: serve the downloaded copy directly to save mobile data.": "클라우드: 실시간 데이터 우선, 다운로드본은 오프라인 대체로 사용. 로컬: 다운로드본을 직접 사용해 모바일 데이터 절약.",
  "Community data feed": "커뮤니티 데이터 피드",
  "Concessionary fare on domestic routes; excl. AEL, EAL First Class, Lo Wu & Lok Ma Chau": "시내 노선은 할인 요금; AEL, 동철 일등석, 로우, 록마차우 제외",
  "Confirm": "확인",
  "Confirm (Enter) or Revert (Esc) Follow roads first": "먼저 도로 추종을 확인(Enter)하거나 되돌리세요(Esc)",
  "Confirm or Revert Follow roads first": "먼저 도로 추종을 확인하거나 되돌리세요",
  "Confirm or Revert the current Follow roads result first": "먼저 현재 도로 추종 결과를 확인하거나 되돌리세요",
  "Confirm or Revert the path first": "먼저 경로를 확인하거나 되돌리세요",
  "Contactless Bank Cards": "비접촉 은행카드",
  "Contribute": "기여",
  "Contribute closed — desktop only": "기여가 닫혔습니다 — 데스크톱 전용",
  "Contribute route path": "노선 경로 기여",
  "Copy JSON": "JSON 복사",
  "Could not copy — use Download instead": "복사할 수 없습니다 — 대신 다운로드하세요",
  "Could not get location": "위치를 가져올 수 없습니다",
  "Could not import JSON": "JSON을 가져올 수 없습니다",
  "Could not load route path": "노선 경로를 로드할 수 없습니다",
  "Could not reach data edge.": "데이터 엣지에 연결할 수 없습니다.",
  "Could not reach the submit API.": "제출 API에 연결할 수 없습니다.",
  "Could not resolve LRT coords for route {r}": "{r} 노선의 경전철 좌표를 확인할 수 없습니다",
  "Couldn’t load nearby routes": "주변 노선을 불러올 수 없습니다",
  "Couldn’t load routes": "노선을 불러올 수 없습니다",
  "Current location": "현재 위치",
  "Data cache": "데이터 캐시",
  "Data cache enabled": "오프라인 데이터 캐시 활성화",
  "Data update available": "데이터 업데이트가 있습니다",
  "Data: MTR open data · Protomaps · OpenStreetMap contributors.": "데이터: MTR 오픈데이터 · Protomaps · OpenStreetMap 기여자.",
  "Dataset status": "데이터셋 상태",
  "Default:": "기본:",
  "Delete ({n})": "삭제({n})",
  "Delete All Data on This Device": "이 기기의 모든 데이터 삭제",
  "Delete all data": "모든 데이터 삭제",
  "Delete all data?": "모든 데이터를 삭제할까요?",
  "Delete selected": "선택 항목 삭제",
  "Deleted {n} points": "{n}개 점을 삭제했습니다",
  "Deleted {n} points · {m} remain · Undo available": "{n}개 점 삭제 · {m}개 남음 · 실행 취소 가능",
  "Deletes every cached byte, preference and onboarding state, then restarts the app.": "모든 캐시 데이터, 환경설정, 온보딩 상태를 삭제한 후 앱을 다시 시작합니다.",
  "Densifying segments OSRM can handle…": "OSRM이 처리할 수 있도록 구간 밀집화 중…",
  "Departure": "출발",
  "Departure · Now (UTC+8)": "출발 · 지금（UTC+8）",
  "Departure · {label}": "출발 · {label}",
  "Departure time (Hong Kong, UTC+8)": "출발 시간（홍콩, UTC+8）",
  "Departure · {time}": "출발 · {time}",
  "Desktop only · mouse/trackpad recommended.": "데스크톱 전용 · 마우스／트랙패드 권장.",
  "Destination": "목적지",
  "Developer": "개발자",
  "Direction": "방향",
  "Done": "완료",
  "Download GTFS": "GTFS 다운로드",
  "Download JSON": "JSON 다운로드",
  "Download JSON copy": "JSON 사본 다운로드",
  "Download PMTiles": "PMTiles 다운로드",
  "Download failed": "다운로드 실패",
  "Download offline data": "오프라인 데이터 다운로드",
  "Download or copy the JSON and share it with moderators if needed.": "필요하면 JSON을 다운로드하거나 복사하여 중재자와 공유하세요.",
  "Downloading offline data…": "오프라인 데이터 다운로드 중…",
  "Downloads": "다운로드",
  "Drag a box on the map · +drag to add · amber = offset from route · red = selected · remove": "지도에서 드래그하여 박스 선택 · +드래그로 추가 · 호박색 = 노선 이탈 · 빨강 = 선택됨 · 제거",
  "Draw or load a path first (need ≥ 2 points)": "먼저 경로를 그리거나 로드하세요(2개 이상 필요)",
  "Drawing route…": "경로 그리는 중…",
  "Drop a .json contribution file": ".json 기여 파일을 놓으세요",
  "E2E testing only — not shipped in the app bundle.": "E2E 테스트 전용 — 앱 번들에 포함되지 않습니다.",
  "EAL First Class": "동철 일등석",
  "ETA route browser": "ETA 노선 브라우저",
  "ETA unavailable · checked {t}": "ETA 사용 불가 · {t} 확인",
  "East Rail Line First Class": "동철선 일등석",
  "Edit mode": "편집 모드",
  "Edit path turns (hollow green) and/or": "경로 꺾임점（속이 빈 초록）편집 및／또는",
  "Enable": "사용",
  "Enter a Destination/Route": "목적지／노선 입력",
  "Enter a route number (e.g. 38, S1, E11).": "노선 번호를 입력하세요(예: 38, S1, E11).",
  "Enter an MTR line code: TWL, ISL, KTL, TML, EAL, TCL, TKL, SIL, DRL, AEL": "MTR 노선 코드를 입력하세요: TWL, ISL, KTL, TML, EAL, TCL, TKL, SIL, DRL, AEL",
  "Est. arrive": "도착 예정",
  "Estimated arrival (Hong Kong time)": "예상 도착 시간（홍콩 시간）",
  "Expand or collapse": "펼치기／접기",
  "Expand or collapse panel": "패널 펼치기／접기",
  "Fare": "요금",
  "Fare · {type}": "요금 · {type}",
  "Fare tables unavailable — times still work": "요금표를 사용할 수 없음 — 시간은 계속 표시됩니다",
  "Fares, line / LRT routes and stops, MTR Bus schedules.": "요금, 노선／경전철 노선과 정류장, MTR 버스 시간표.",
  "Fastest": "최속",
  "Fetch more live data": "실시간 데이터 더 가져오기",
  "Fetch more live data disabled": "실시간 데이터 더 가져오기 비활성화됨",
  "Fetch more live data enabled": "실시간 데이터 더 가져오기 활성화됨",
  "Fetch the full dataset for offline use. This will be the main data source if preferred in the “Prefer data source” setting above.": "오프라인 사용을 위해 전체 데이터셋을 가져옵니다. 위의「데이터 소스 우선」설정에서 선택된 경우 이것이 주요 데이터 소스가 됩니다.",
  "Fewer transfers preferred": "환승 적은 경로 우선",
  "Filter stops:": "정류장 필터:",
  "Finishing…": "마무리 중…",
  "First-party code": "자체 코드",
  "Fixed time": "지정 시간",
  "Follow roads": "도로 따라가기",
  "Follow roads calculation": "도로 따라가기 계산",
  "Follow roads confirmed": "도로 추종을 확인했습니다",
  "Follow roads confirmed · {n} path pts · Undo still available · Hide overlay when done": "도로 추종 확인됨 · 경로 점 {n}개 · 실행 취소 가능 · 완료 후 오버레이 숨기기",
  "Follow roads reverted": "도로 추종을 되돌렸습니다",
  "Follow roads reverted · {n} path pts restored": "도로 추종 되돌림 · 경로 점 {n}개 복원됨",
  "Recalculate path": "경로 재계산",
  "Recalc preview: {ins} road pts via {n} section(s) · {before}→{after} pts — Confirm or Revert": "재계산 미리보기: 도로로 {ins}개 점 재구성 · {n}개 구간 · {before}→{after}개 점 — 확인 또는 되돌리기",
  "Couldn't reroute along roads — OSRM is unavailable. Path unchanged.": "도로를 따라 재구성할 수 없습니다 — OSRM을 사용할 수 없습니다. 경로는 변경되지 않았습니다.",
  "Recalculate needs a connection — you appear to be offline.": "재계산에는 네트워크 연결이 필요합니다 — 오프라인 상태인 것 같습니다.",
  "Road assistant: recalculating section {i}/{n}…": "도로 어시스턴트: 구간 {i}/{n} 재계산 중…",
  "Road assistant stopped: OSRM is rate-limiting or down — try again in a minute.": "도로 어시스턴트 중지: OSRM 요청 제한 또는 접근 불가 — 1분 후 다시 시도하세요.",
  "Follow-roads overlay hidden": "도로 추종 오버레이를 숨겼습니다",
  "Add blocker": "차단점 추가",
  "Blocker added": "차단점을 추가했습니다",
  "Blocker added — Follow roads will avoid this junction": "차단점 추가됨 — 도로 따라가기가 이 교차로를 피합니다",
  "Blocker already there": "이미 차단점이 있습니다",
  "Blocker placement off": "차단점 배치를 종료했습니다",
  "Blocker removed": "차단점을 제거했습니다",
  "Blockers cleared": "차단점을 지웠습니다",
  "blockers": "차단점",
  "Cannot set the first point as last": "첫 점을 종점으로 설정할 수 없습니다",
  "Clear blockers": "차단점 지우기",
  "Click the map to drop a blocker": "지도를 눌러 차단점을 놓으세요",
  "Focused point {n} · 1 = start here · 2 = last here": "{n}번 점 선택 · 1 = 여기서 시작 · 2 = 여기서 끝",
  "Junction blocker (avoid this road)": "교차로 차단점 (이 도로 피하기)",
  "Line now ends here": "선이 여기서 끝납니다",
  "Line start moved here": "선 시작점을 여기로 옮겼습니다",
  "loop": "순환",
  "Mode: Path turns (V) — drag rings · arrows show direction · 1 start · 2 last": "모드: 경로 꺾임（V）— 링 드래그 · 화살표가 방향 · 1 시작 · 2 끝",
  "Mode: Select (B) — box-select · Follow roads snaps selected only": "모드: 선택（B）— 상자 선택 · 도로 따라가기는 선택 점만",
  "Need a focused path point — click a green ring first": "먼저 초록 링을 눌러 점을 고르세요",
  "Zoom Chord": "줌 현",
  "Zoom Chord disabled": "줌 현을 껐습니다",
  "Zoom Chord enabled": "줌 현을 켰습니다",
  "On non-contributed bus routes, road-snap the GTFS line onto OpenStreetMap roads when you zoom in. Uses the on-device street graph with OSRM only as backup.": "기여되지 않은 버스 노선은 확대 시 GTFS 선을 OpenStreetMap 도로에 붙입니다. 기기 내 도로 그래프로 계산하며 OSRM은 예비로만 사용합니다.",
  "Path already ends here": "이미 여기서 끝납니다",
  "Path already starts here": "이미 여기서 시작합니다",
  "Path end set · {n} pts remain": "종점 설정 · {n}개 점 남음",
  "Path mode: drag rings · click a ring then 1/2 for start/last · Shift+click blocker · R Follow roads": "경로 모드: 링 드래그 · 링을 누른 뒤 1/2로 시작/끝 · Shift+클릭으로 차단점 · R 도로 따라가기",
  "Path rotated · this point is now the start": "경로를 회전했습니다 · 이 점이 시작입니다",
  "Placing blockers — click the wrong road at a junction · Esc to stop": "차단점 배치 — 교차로에서 잘못된 도로를 클릭 · Esc로 종료",
  "Select mode: Follow roads snaps selected points only. Select some, or leave Select mode to snap all.": "선택 모드: 도로 따라가기는 선택한 점만 붙입니다. 점을 고르거나 선택 모드를 나가 전체를 붙이세요.",
  "Select mode: box-select · Follow roads snaps selected points only · Del removes": "선택 모드: 상자 선택 · 도로 따라가기는 선택 점만 · Del로 삭제",
  "Select mode (B) — Follow roads snaps selected points only": "선택 모드（B）— 도로 따라가기는 선택 점만",
  "Select points first, or press V to snap the whole path": "먼저 점을 고르거나 V로 전체 경로를 붙이세요",
  "Service disruption": "운행 장애",
  "Set as last": "종점으로",
  "START": "시작",
  "END": "끝",
  "Start here": "여기서 시작",
  "Cutoff stop (by sequence — not the overlapping pin)": "구분 정류장 (순서 — 겹친 핀은 쓰지 마세요)",
  "hidden": "숨김",
  "Previous stop": "이전 정류장",
  "Next stop": "다음 정류장",
  "Hide before": "이전 숨기기",
  "Hide after": "이후 숨기기",
  "Show all": "모두 표시",
  "Showing all": "모두 표시함",
  "Showing all stops and path": "정류장과 경로를 모두 표시",
  "Click a stop pin first, then Hide before / Hide after": "먼저 정류장 핀을 누른 뒤 이전/이후를 숨기세요",
  "Nothing before the first stop": "첫 정류장 앞에는 숨길 것이 없습니다",
  "Nothing after the last stop": "마지막 정류장 뒤에는 숨길 것이 없습니다",
  "showing {n}/{m}": "{n}/{m} 표시",
  "Showing from #{n} {name} · hidden {k} stops before · 0 to show all": "#{n} {name}부터 표시 · 이전 {k}개 숨김 · 0으로 모두 표시",
  "Showing through #{n} {name} · hidden {k} stops after · 0 to show all": "#{n} {name}까지 표시 · 이후 {k}개 숨김 · 0으로 모두 표시",
  "Focused stop #{n} {name} · [ hide before · ] hide after · 0 show all": "#{n} {name} 선택 · [ 이전 숨김 · ] 이후 숨김 · 0 모두 표시",
  "Mode: Visual stops (S) — click a stop then [ hide before / ] hide after": "모드: 정류장（S）— 핀을 누른 뒤 [ 이전 숨김 / ] 이후 숨김",
  "Visual stops: click a pin then [ / ] to hide the other half of a circular · drag to adjust": "정류장: 핀을 누른 뒤 [ / ]로 순환의 다른 반을 숨김 · 드래그로 조정",
  "Fonts": "글꼴",
  "Free MTR link": "MTR 무료 연결 통로",
  "Free MTR link: {from} → {to}": "MTR 무료 연결 통로: {from} → {to}",
  "From": "출발지",
  "From plan": "경로에서",
  "Full route": "전체 노선",
  "GMB": "미니버스",
  "GMB (green minibus)": "미니버스（그린 미니버스）",
  "GMB route code required": "GMB 노선 코드가 필요합니다",
  "GMB route {code} not found. Try the public code (e.g. 1, 44A).": "GMB 노선 {code}을(를) 찾을 수 없습니다. 공개 코드(예: 1, 44A)를 시도하세요.",
  "GTFS feed builder (© 2025 Wheels Transit) behind hk.gtfs.zip and the routing graph; feed data is derived from the government sources above.": "hk.gtfs.zip과 경로 탐색 그래프의 기반이 되는 GTFS 피드 빌더（© 2025 Wheels Transit）; 피드 데이터는 위의 정부 소스에서 파생.",
  "GTFS → .wheelsrouter graph compiler, run in CI (wheels-router-nano ecosystem; not shipped).": "GTFS → .wheelsrouter 그래프 컴파일러, CI에서 실행（wheels-router-nano 생태계; 포함되지 않음）.",
  "Getting your location…": "현재 위치를 가져오는 중…",
  "GitHub Repository": "GitHub 저장소",
  "GitHub account": "GitHub 계정",
  "GitHub login failed": "GitHub 로그인에 실패했습니다",
  "GitHub login finished": "GitHub 로그인이 완료되었습니다",
  "GitHub login required": "GitHub 로그인이 필요합니다",
  "Gov open data terms": "정부 오픈데이터 이용 약관",
  "Green minibus routes, stops and ETAs.": "그린 미니버스 노선, 정류장, ETA.",
  "Hide ETA to browse the full stop list": "ETA를 숨기고 전체 정류장 보기",
  "Hide beta banner for this session": "이번 세션 동안 베타 배너 숨기기",
  "Hide beta banner?": "베타 배너를 숨길까요?",
  "Hide calculation overlay": "계산 오버레이 숨기기",
  "High (more data)": "높음 (데이터 추가)",
  "High accuracy": "높은 정확도",
  "Holiday": "공휴일",
  "Hong Kong Community GTFS": "홍콩 커뮤니티 GTFS",
  "Hong Kong map": "홍콩 지도",
  "Hong Kong transit map & trip planner. Routes use the public GTFS graph (RAPTOR) with Octopus adult fare estimates. Search supports": "홍콩 교통 지도 및 경로 플래너. 노선은 공개 GTFS 그래프（RAPTOR）를 사용하며 옥토퍼스 성인 요금 추정치를 제공합니다. 검색 지원",
  "I agree to all terms and policies": "모든 약관 및 정책에 동의합니다",
  "I agree to the Terms of Service and Privacy Policy": "서비스 약관 및 개인정보 처리방침에 동의합니다",
  "I understand": "이해했습니다",
  "Import JSON": "JSON 가져오기",
  "Import a downloaded contribution JSON to continue editing": "다운로드한 기여 JSON을 가져와 편집 계속",
  "Import failed": "가져오기에 실패했습니다",
  "Imported JSON · {n} points": "JSON 가져옴 · 점 {n}개",
  "Imported {id} · {n} path pts · {m} visual stops · continue editing": "{id} 가져옴 · 경로 점 {n}개 · 시각적 정류장 {m}개 · 편집 계속",
  "In-station interchange": "역내 환승",
  "In-station interchange at {place}": "{place}에서 역내 환승",
  "Inbound / I / DOWN / seq 2": "하행／I／DOWN／seq 2",
  "Indoor interchange": "실내 환승",
  "Indoor interchange: {from} → {to}": "실내 환승: {from} → {to}",
  "Invalid JSON object": "유효하지 않은 JSON 객체입니다",
  "Invalid place": "유효하지 않은 장소",
  "JSON copied": "JSON을 복사했습니다",
  "JSON copied to clipboard": "JSON을 클립보드에 복사했습니다",
  "JSON downloaded": "JSON을 다운로드했습니다",
  "JSON needs coordinates with at least 2 [lon,lat] points": "JSON에는 [lon,lat] 좌표 점이 최소 2개 필요합니다",
  "JoyYou $2/20% scheme; full adult for AEL, Lo Wu, Lok Ma Chau & Racecourse": "JoyYou $2／20% 제도; AEL, 로우, 록마차우, 경마장은 성인 요금",
  "KMB": "KMB",
  "KMB / Citybus": "KMB／시티버스",
  "KMB / LWB": "KMB／LWB",
  "KMB/LWB": "KMB／LWB",
  "Keep banner": "배너 유지",
  "LIVE": "실시간",
  "LRT": "경전철",
  "LRT route CSV empty": "경전철 노선 CSV가 비어 있습니다",
  "LRT route number required (e.g. 505, 507, 610)": "경전철 노선 번호가 필요합니다(예: 505, 507, 610)",
  "LWB": "LWB",
  "Language": "언어",
  "Language · {label}": "언어 · {label}",
  "Last point removed": "마지막 점을 제거했습니다",
  "Later": "나중에",
  "Least fare": "최저 요금",
  "Licenses": "라이선스",
  "Light Rail": "경전철",
  "Light Rail (LRT)": "경전철（LRT）",
  "Live": "실시간",
  "Live ETAs · {liveN}/{total} routes · {t} · refreshes every 1 min": "실시간 ETA · {liveN}/{total}개 노선 · {t} · 1분마다 갱신",
  "Live ETAs failed — will retry": "실시간 ETA 실패 — 재시도합니다",
  "Live OSRM path · {stops} stops · {n} pts (no matching published path). Press R to follow roads.": "실시간 OSRM 경로 · 정류장 {stops}개 · 점 {n}개(일치하는 게시 경로 없음). R을 눌러 도로 추종.",
  "Live Position Engine": "실시간 위치 엔진",
  "Live Position Engine (Prediction-based)": "실시간 위치 엔진 (예측 기반)",
  "Live Position Engine disabled": "실시간 위치 엔진 비활성화됨",
  "Live Position Engine enabled": "실시간 위치 엔진 활성화됨",
  "Live arrivals": "실시간 도착",
  "Live bus positions": "버스 실시간 위치",
  "Live bus positions disabled": "실시간 버스 위치 비활성화됨",
  "Live bus positions enabled": "실시간 버스 위치 활성화됨",
  "Live est. arrive": "실시간 도착 예정",
  "Live {liveN} · Scheduled {schedN} · {total} routes · {t}": "실시간 {liveN} · 예정 {schedN} · 총 {total}개 노선 · {t}",
  "Load a calculated path or draw at least 2 points.": "계산된 경로를 로드하거나 최소 2개 이상 그리세요.",
  "Load a path first": "먼저 경로를 로드하세요",
  "Load calculated path": "계산된 경로 불러오기",
  "Load failed": "로드 실패",
  "Load path": "경로 불러오기",
  "Load path not supported for operator {ag} yet — use From plan or draw": "{ag} 사업자의 경로 로드를 아직 지원하지 않습니다 — 계획에서 또는 직접 그리세요",
  "Loaded calculated path from plan ({n} pts). Follow roads (R) to hug streets, then edit.": "계획에서 계산된 경로를 로드했습니다(점 {n}개). R로 도로 추종하여 도로에 붙인 후 편집하세요.",
  "Loaded path from current plan": "현재 계획에서 경로를 로드했습니다",
  "Loading WASM router…": "WASM 라우터 불러오는 중…",
  "Loading nearby routes…": "주변 노선 로딩 중…",
  "Loading route…": "노선 불러오는 중…",
  "Loading routes…": "노선 불러오는 중…",
  "Loading stops + checking published overrides…": "정류장 로드 중 + 게시된 오버라이드 확인 중…",
  "Loading {co} {id}…": "{co} {id} 로딩 중…",
  "Loading {n} pinned route{s}…": "고정 정류장 {n}개{s} 로딩 중…",
  "Loading {n} pinned stop{s}…": "고정 정류장 {n}개{s} 로딩 중…",
  "Loads this route’s published override if any; otherwise a": "이 노선의 게시된 오버라이드가 있으면 로드하고, 없으면",
  "Local": "로컬",
  "Location permission denied": "위치 권한이 거부되었습니다",
  "Location request timed out": "위치 요청 시간이 초과되었습니다",
  "Location unavailable": "위치를 사용할 수 없습니다",
  "Log in and open a PR from": "로그인하고",
  "Log in with GitHub": "GitHub로 로그인",
  "Log in with GitHub first (or switch to Bot account)": "먼저 GitHub에 로그인하세요(또는 Bot 계정으로 전환)",
  "Log in with GitHub to submit with your account, or switch to Bot account.": "GitHub에 로그인하여 내 계정으로 제출하거나 Bot 계정으로 전환하세요.",
  "Log out": "로그아웃",
  "Logged out of GitHub": "GitHub에서 로그아웃했습니다",
  "Lower fare preferred": "저렴한 요금 우선",
  "MTR": "MTR",
  "MTR (heavy rail)": "MTR（중량철도）",
  "MTR Corporation open data": "MTR 공사 오픈 데이터",
  "MTR ends": "MTR 종점",
  "MTR open data terms": "MTR 오픈 데이터 약관",
  "MTR preferred": "MTR 우선",
  "Main": "메인",
  "Map": "지도",
  "Map data and services": "지도 데이터와 서비스",
  "Map error: {msg}": "지도 오류: {msg}",
  "Map failed to load tiles": "지도 타일을 불러올 수 없습니다",
  "Map ready · streaming hongkong.pmtiles": "지도 준비 완료 · hongkong.pmtiles 스트리밍",
  "Map rendering engine (MapLibre contributors).": "지도 렌더링 엔진（MapLibre 기여자）。",
  "Map rendering paused — recovering…": "지도 렌더링 일시 중지 — 복구 중…",
  "Map resumed": "지도가 재개되었습니다",
  "Map unavailable": "지도를 사용할 수 없습니다",
  "Map didn't recover — reloading…": "지도가 복구되지 않음 — 다시 로드 중…",
  "Metadata unavailable — map may still load from PMTiles URL": "메타데이터 사용 불가 — 지도는 PMTiles URL에서 로드될 수 있습니다",
  "Minimise journey time": "이동 시간 최소화",
  "Mode": "모드",
  "Mode · {day}": "모드 · {day}",
  "Mode: Path turns (V) — drag hollow green rings": "모드: 경로 꺾임점（V）— 속이 빈 초록 링을 드래그",
  "Modes · {methods}": "모드 · {methods}",
  "MTR Bus": "MTR 버스",
  "Meet at {place}": "{place}에서 만나기",
  "Meet friends here": "여기서 만나기",
  "Meet friends here (optional)": "여기서 만나기（선택）",
  "Nearby": "주변",
  "A new version of MORGAN Travelers is ready. Reload now to get it?": "MORGAN Travelers의 새 버전이 준비되었습니다. 지금 다시 로드할까요?",
  "Bus · {label}": "버스 · {label}",
  "Data cache disabled — data source reset to Cloud": "오프라인 데이터 캐시 비활성화 — 데이터 소스를 클라우드로 재설정",
  "Fare · {fare}": "요금 · {fare}",
  "Mode · {mode}": "모드 · {mode}",
  "Modes · {modes}": "교통수단 · {modes}",
  "MORGAN Travelers (main app)": "MORGAN Travelers (메인 앱)",
  "N/A": "해당 없음",
  "NLB": "NLB",
  "Need at least 2 path points": "경로 점이 최소 2개 필요합니다",
  "Next": "다음",
  "No GMB stops for {code} seq {seq}": "GMB {code} seq {seq} 정류장을 찾을 수 없습니다",
  "No LRT stops for route {r} direction {dir}. Check route no. (e.g. 505).": "{r} 노선 {dir} 방향의 경전철 정류장을 찾을 수 없습니다. 노선 번호를 확인하세요(예: 505).",
  "No departure": "출발 없음",
  "No departure data": "출발 데이터 없음",
  "No draft to copy": "복사할 초안이 없습니다",
  "No draft to download": "다운로드할 초안이 없습니다",
  "No large offsets found": "큰 오프셋이 없습니다",
  "No nearby routes": "주변에 노선 없음",
  "No offset points over {m}m — path is clean enough": "{m}m 초과 오프셋 점이 없습니다 — 경로가 충분히 깨끗합니다",
  "No override for this route — using similar published path from {from} (shared corridor) · {n} pts. Edit & submit your own.": "이 노선의 오버라이드가 없습니다 — {from}의 유사 게시 경로 사용(공유 구간) · {n}개 점. 편집하여 직접 제출하세요.",
  "No places found": "장소를 찾을 수 없습니다",
  "No places found — try “Yuen Long Station”, @MTR, or tap the map": "장소를 찾을 수 없습니다 — \"Yuen Long Station\", @MTR을 시도하거나 지도를 탭하세요",
  "No places match “{q}”": "「{q}」에 맞는 장소 없음",
  "No plan selected — search a route instead": "선택된 계획이 없습니다 — 대신 노선을 검색하세요",
  "No points in box (endpoints are protected)": "상자 안에 점이 없습니다(끝점은 보호됨)",
  "No points selected": "선택된 점이 없습니다",
  "No routes found": "노선을 찾을 수 없음",
  "No routes found — try other points": "노선을 찾을 수 없음 — 다른 지점을 시도하세요",
  "No routes found through via — try another meeting point": "이 경유지를 지나는 노선을 찾을 수 없습니다 — 다른 만남 장소를 시도하세요",
  "No routes found.": "노선을 찾을 수 없습니다.",
  "No routes match “{q}”": "「{q}」에 맞는 노선 없음",
  "No routes or places for “{q}”": "\"{q}\"에 대한 노선이나 장소가 없습니다",
  "No station coords found for MTR {line}": "MTR {line} 역 좌표를 찾을 수 없습니다",
  "No stop list for {co} {id}.": "{co} {id}의 정류장 목록이 없습니다.",
  "No stops found for {ag} {r} ({dir})": "{ag} {r}({dir}) 정류장을 찾을 수 없습니다",
  "No transit legs for ETA": "ETA 대상 교통 구간이 없습니다",
  "No usable stops after merge for {ag} {r}": "{ag} {r} 병합 후 사용 가능한 정류장이 없습니다",
  "No valid coordinates in JSON": "JSON에 유효한 좌표가 없습니다",
  "No {mode} stops matched — try another name": "일치하는 {mode} 정류장이 없습니다 — 다른 이름을 시도하세요",
  "No, use cloud only": "아니요, 클라우드만 사용합니다",
  "Not now": "지금은 안 함",
  "Notes for moderators": "운영자 메모",
  "Nothing in box": "상자 안에 항목이 없습니다",
  "Nothing to confirm": "확인할 항목이 없습니다",
  "Nothing to redo": "다시 실행할 항목이 없습니다",
  "Nothing to revert": "되돌릴 항목이 없습니다",
  "Nothing to undo": "실행 취소할 항목이 없습니다",
  "Now": "지금",
  "Octopus Adult/Elderly": "옥토퍼스 성인／노인",
  "Octopus Child": "옥토퍼스 아동",
  "Octopus JoyYou Cards (60–64)": "JoyYou 카드（60–64세）",
  "Octopus JoyYou Cards (65+)": "JoyYou 카드（65세 이상）",
  "Octopus Student": "옥토퍼스 학생",
  "Off": "꺼짐",
  "Offline Data": "오프라인 데이터",
  "Offline data": "오프라인 데이터",
  "Offline — using downloaded data": "오프라인 — 다운로드 데이터 사용 중",
  "Offline data ready": "오프라인 데이터 준비 완료",
  "On": "켜짐",
  "Onboarding": "온보딩",
  "Open source & data licenses": "오픈소스 및 데이터 라이선스",
  "Operator / mode": "운수사／모드",
  "Operator and route required": "사업자와 노선이 필요합니다",
  "Opposite": "반대 방향",
  "Optional experimental features. You can change these anytime in Settings.": "선택적인 실험 기능입니다. 언제든지 설정에서 변경할 수 있습니다.",
  "Origin": "출발지",
  "Origin set to current location": "출발지가 현재 위치로 설정되었습니다",
  "Origin suggestions": "출발지 추천",
  "Original path (before)": "원래 경로（이전）",
  "Other / joint": "기타／공동 운행",
  "Outbound / O / UP / seq 1": "상행／O／UP／seq 1",
  "Outside service": "운행 시간 외",
  "Outside service hours": "운행 시간 외",
  "Override path loaded{id} · {n} pts": "오버라이드 경로 {id} 로드 · 점 {n}개",
  "Path cleared": "경로를 지웠습니다",
  "Path contributions are desktop-only (wide screen + mouse/trackpad).": "경로 기여는 데스크톱 전용입니다(넓은 화면 + 마우스/트랙패드).",
  "Path loaded · {stops} stops · {n} pts (live densify)": "경로 로드 · 정류장 {stops}개 · 점 {n}개(실시간 밀집화)",
  "Path mode: drag hollow green handles · click path to insert · Alt+click delete · B for select": "경로 모드: 속이 빈 녹색 핸들 드래그 · 경로 클릭하여 삽입 · Alt+클릭 삭제 · B 선택",
  "Path redone": "경로를 다시 실행했습니다",
  "Path turning points (V)": "경로 꺾임점（V）",
  "Path turns": "경로 꺾임",
  "Path turns mode (V)": "경로 꺾기 모드 (V)",
  "Path unchanged — debug overlay shows why": "경로가 변경되지 않았습니다 — 디버그 오버레이에 이유가 표시됩니다",
  "Path undone": "경로를 실행 취소했습니다",
  "Pick a via place from the list, or clear Via": "목록에서 경유지를 고르거나 경유를 지우세요",
  "Planning via {place}…": "{place} 경유 경로 계획 중…",
  "Planning…": "경로 계획 중…",
  "Pin": "고정",
  "Pin plan": "핀 고정",
  "Pin route": "노선 고정",
  "Pin stop": "정류장 고정",
  "Pin this route to the toolbar": "이 노선을 도구 모음에 고정",
  "Pin this stop": "이 정류장 고정",
  "Pin this trip": "이 경로 고정",
  "Pinned": "고정됨",
  "Pinned Routes": "핀 고정된 정류장",
  "Pinned Stops": "핀 고정된 정류장",
  "Pinned routes": "고정된 정류장",
  "Pinned stops": "고정된 정류장",
  "Pinned Trips": "고정된 여정",
  "Nothing pinned yet": "아직 고정한 항목이 없습니다",
  "Pin trip plans from Plan Results, or open a route, pick a stop, then tap Pin.": "경로 결과에서 여정을 고정하거나, 노선에서 정류장을 연 뒤 고정하세요.",
  "Pin a route stop or trip plan": "정류장 또는 여정을 고정",
  "No pinned items": "고정된 항목 없음",
  "Show detail": "상세 보기",
  "Open pinned {id}": "고정된 {id} 열기",
  "Open {n} pinned stops": "고정된 정류장 {n}개 열기",
  "Open {n} pinned trips": "고정된 여정 {n}개 열기",
  "Open {n} pinned items": "고정된 항목 {n}개 열기",
  "Place": "장소",
  "Place search / reverse geocoding (service).": "장소 검색／역지오코딩（서비스）。",
  "Place search returned invalid JSON — is /geocode proxy running?": "장소 검색이 잘못된 JSON을 반환했습니다 — /geocode 프록시가 실행 중인가요?",
  "Places": "장소",
  "Places · tap to plan trip": "장소 · 탭하여 경로 계획",
  "Plan Results": "경로 결과",
  "Plan failed: {msg}": "경로 검색 실패: {msg}",
  "Plan trip": "경로 검색",
  "Platform {p}": "{p}번 승강장",
  "Please get on the {noun} at {place}": "{place}에서 {noun}을(를) 타세요",
  "Please get on the {noun} at {station}": "{station}에서 {noun}을(를) 타세요",
  "Please review and accept all terms and policies to continue.": "계속하려면 모든 약관 및 정책을 검토하고 동의해 주세요.",
  "Please review and accept our Terms of Service and Privacy Policy to continue.": "계속하려면 서비스 약관과 개인정보 처리방침을 검토하고 동의해 주세요.",
  "Predicted bus positions (busPositionEngine, trafficSpeed, busSchedules). Source under GNU GPLv3 only; see licenses/GPL-3.0.txt.": "예측 버스 위치(busPositionEngine, trafficSpeed, busSchedules). 소스는 GNU GPLv3 전용. licenses/GPL-3.0.txt 참고.",
  "Predicted Live Positions are for reference only.": "예측 버스 위치는 참고용입니다.",
  "Prediction accuracy": "예측 정확도",
  "Prefer": "우선",
  "Prefer data source": "데이터 소스 우선",
  "Prefer {label}": "우선: {label}",
  "Prefer {prefer} data": "{prefer} 데이터 우선",
  "Prefer {prefs}": "우선 {prefs}",
  "Preparing manifest…": "매니페스트 준비 중…",
  "Preparing offline data…": "오프라인 데이터 준비 중…",
  "Preview only —": "미리보기 전용 —",
  "Preview: {snap} snapped · {raw} raw · {dens} densified · {fail} kept · {before}→{after} pts — Confirm or Revert": "미리보기: 스냅 {snap} · 원시 {raw} · 밀집화 {dens} · 유지 {fail} · {before}→{after} 점 — 확인 또는 되돌리기",
  "Privacy Policy": "개인정보 처리방침",
  "Profile": "프로필",
  "Profile menu": "프로필 메뉴",
  "Published override loaded{id} · {n} path pts · {stops} stops. Edit & re-submit to improve, or Follow roads (R).": "게시된 오버라이드 {id} 로드됨 · 경로 점 {n}개 · 정류장 {stops}개. 편집 후 재제출로 개선하거나 도로 추종(R).",
  "QR Code Adult/Elderly": "QR 코드 성인／노인",
  "QR Code Child": "QR 코드 아동",
  "RBS": "주민버스",
  "Re-run onboarding": "온보딩 다시 실행",
  "Recommended": "추천",
  "Redo": "다시 실행",
  "Redo (⌘/Ctrl+Shift+Z or ⌘/Ctrl+Y)": "다시 실행（⌘/Ctrl+Shift+Z 또는 ⌘/Ctrl+Y）",
  "Redo · {n} path pts · {u} undo · {r} redo": "다시 실행 · 경로 점 {n}개 · 실행 취소 {u} · 다시 실행 {r}",
  "Reload": "새로고침",
  "Reload now to fully apply the new language?": "새 언어를 완전히 적용하려면 새로고침이 필요합니다. 지금 새로고침할까요?",
  "Reload once so the service worker is active": "service worker를 활성화하려면 한 번 다시 로드하세요",
  "Reload to apply language?": "언어를 적용하려면 새로고침할까요?",
  "Required for “GitHub account” submit.": "「GitHub 계정」제출에 필요합니다.",
  "Reset departure time to now": "출발 시간을 지금으로 초기화",
  "Reset to now (UTC+8)": "지금（UTC+8）으로 초기화",
  "Residents' Bus Services (RBS, e.g. Ma Wan NR330/NR332 and Discovery Bay DB routes) charge a lower fare when paying with a registered Octopus card. Off = visitor fare.": "주민버스（RBS, 예: 마완 NR330/NR332, 디스커버리베이 DB 노선）는 등록된 옥토퍼스 카드로 결제 시 요금이 낮아집니다. 꺼짐 = 방문객 요금.",
  "Restart now": "지금 다시 시작",
  "Restart to load the latest data from the cloud.": "다시 시작하면 클라우드의 최신 데이터를 불러옵니다.",
  "Resume a downloaded draft (or drop a": "다운로드한 초안 재개(또는 ",
  "Restored your in-progress edit": "편집 중인 내용을 복원했습니다",
  "Retry": "재시도",
  "Revert": "되돌리기",
  "Review the map · Confirm to keep · Revert to undo": "지도 확인 · 확인으로 유지 · 되돌리기로 실행 취소",
  "Ride {n} stop{s}": "{n}개 정류장 탑승",
  "Road assistant failed": "도로 어시스턴트가 실패했습니다",
  "Road assistant: nothing changed — see map legend (grey=original, amber=kept raw).": "도로 어시스턴트: 변경 사항 없음 — 지도 범례 참조(회색=원본, 앰버=원시 유지).",
  "Road assistant: snapping vertices onto streets (keeps all your points)…": "도로 어시스턴트: 도로에 꼭짓점 스냅 중(모든 점 유지)…",
  "Road assistant: {msg}": "도로 어시스턴트: {msg}",
  "Road-network geometry for bus-route snapping (service; data © OSM contributors).": "버스 노선 스냅용 도로망 지오메트리（서비스; 데이터 © OSM 기여자）。",
  "Route / fare dataset used for GMB and ferry fare fallbacks; used per its citation notice (HK Bus Crawling @2021).": "미니버스와 페리 요금 폴백에 사용되는 노선／요금 데이터셋; 인용 고지에 따라 사용（HK Bus Crawling @2021）。",
  "Route / line": "노선／선로",
  "Route detail": "노선 상세",
  "Route detail actions": "노선 상세 작업",
  "Route preferences": "경로 우선 설정",
  "Router failed: {msg}": "경로 엔진 오류: {msg}",
  "Router graph failed to load": "라우터 그래프를 불러오지 못했습니다",
  "Routes": "노선",
  "Runtime open source": "런타임 오픈소스",
  "Same rates as Octopus Adult": "옥토퍼스 성인과 동일 요금",
  "Same rates as Octopus Adult/Elderly": "옥토퍼스 성인／노인과 동일 요금",
  "Same rates as Octopus Child": "옥토퍼스 아동과 동일 요금",
  "Sched": "예정",
  "SCHEDULED": "예정",
  "Saved locally to the overrides pending folder. Open the review page or merge via npm run overrides:merge.": "로컬 overrides pending 폴더에 저장되었습니다. 검토 페이지를 열거나 npm run overrides:merge로 병합하세요.",
  "Scheduled departures": "예정 출발",
  "Search": "검색",
  "Search destination or route": "목적지 또는 노선 검색",
  "Search failed": "검색 실패",
  "Search unavailable — run npm run dev (needs /geocode proxy), or tap the map": "검색을 사용할 수 없습니다 — npm run dev 실행(/geocode 프록시 필요) 또는 지도를 탭하세요",
  "Searching…": "검색 중…",
  "Segment densified + inserted mids": "구간 밀도화 + 중간점 삽입",
  "Segment left as-is": "구간 그대로 유지",
  "Segment {n}/{total}": "구간 {n}/{total}",
  "Select": "선택",
  "Select a route first": "먼저 노선을 선택하세요",
  "Select an operator / mode (KMB, GMB, MTR, AEL, LRT, …).": "사업자/모드를 선택하세요(KMB, GMB, MTR, AEL, LRT, …).",
  "Select at least one bus company": "버스 회사를 하나 이상 선택하세요",
  "Select at least one preference": "우선 설정을 하나 이상 선택하세요",
  "Select at least one traffic method": "교통수단을 하나 이상 선택하세요",
  "Select mode (B)": "선택 모드 (B)",
  "Select mode (B) — box-select offset points": "선택 모드 (B) — 오프셋 점 박스 선택",
  "Select mode (B) — box-select · O for offsets": "선택 모드 (B) — 박스 선택 · O는 오프셋",
  "Select mode: drag a box on the map · amber = offset >{n}m · Delete/Backspace removes selected": "선택 모드: 지도에서 박스 드래그 · 앰버 = 오프셋 >{n}m · Delete/Backspace로 선택 제거",
  "Select offsets": "오프셋 선택",
  "Select operator and enter route number first": "먼저 사업자를 선택하고 노선 번호를 입력하세요",
  "Selected {n} offset points (>{m}m from route backbone). Delete to clean, or box-select more.": "오프셋 점 {n}개 선택됨(노선 기준선에서 >{m}m). 삭제하여 정리하거나 더 박스 선택하세요.",
  "Selection cleared": "선택을 지웠습니다",
  "Select…": "선택…",
  "Service day mode": "운행일 모드",
  "Settings": "설정",
  "Show ETA at this stop": "이 정류장의 ETA 보기",
  "Show live bus markers predicted from nearby ETA countdowns.": "인근 정류장의 도착 예정 시간으로 추정한 버스 실시간 위치 마커를 표시합니다.",
  "Show live markers predicted from nearby ETA countdowns.": "인근 정류장의 도착 예정 시간으로 추정한 실시간 위치 마커를 표시합니다.",
  "Show live markers on bus route maps — estimates stitched from the ETA countdowns of nearby stops, not official GPS.": "버스 노선 지도에 실시간 마커 표시 — 공식 GPS가 아닌 인근 정류장의 ETA 카운트다운에서 보간한 추정치.",
  "Show live markers on route maps — estimates stitched from the ETA countdowns of nearby stops, not official GPS.": "노선 지도에 실시간 마커 표시 — 공식 GPS가 아닌 인근 정류장의 ETA 카운트다운에서 보간한 추정치.",
  "Show route details": "노선 상세 보기",
  "Show the “Beta Feature” disclaimer while live bus positions are active. Swipe the banner up to hide it for the session.": "버스 실시간 위치가 활성화된 동안「베타 기능」고지 배너를 표시합니다. 배너를 위로 스와이프하면 이번 세션 동안 숨겨집니다.",
  "Show the “Beta Feature” disclaimer while the Live Position Engine is active. Swipe the banner up to hide it for the session.": "실시간 위치 엔진이 활성화된 동안「베타 기능」고지 배너를 표시합니다. 배너를 위로 스와이프하면 이번 세션 동안 숨겨집니다.",
  "Showing @{mode} stops": "@{mode} 정류장 표시 중",
  "Signed in as @{login}": "@{login}(으)로 로그인됨",
  "Similar override ({from}) · {n} pts": "유사 오버라이드 ({from}) · 점 {n}개",
  "Simplest": "가장 간단",
  "Single Ride Ticket/Cash": "단일 승차권／현금",
  "Skip": "건너뛰기",
  "Skipped a via that is too close to another point": "다른 지점과 너무 가까운 경유지를 건너뛰었습니다",
  "Snap link (old → new)": "스냅 링크（이전 → 새）",
  "Snap visuals": "스냅 시각화",
  "Snap your path onto nearby road edges only — does not re-route (R)": "경로를 가까운 도로 가장자리에만 스냅 — 경로 재탐색은 하지 않음（R）",
  "Snapping vertices to nearest road…": "꼭짓점을 가장 가까운 도로에 스냅 중…",
  "Snaps your vertices onto nearby streets. Never deletes points — only adds road detail where OSRM can; weak sections stay as you drew them. Result is drawn on the map as a calculation overlay.": "정점을 가까운 도로에 스냅합니다. 점을 삭제하지 않습니다 — OSRM이 가능한 곳에만 도로 세부 정보를 추가하고, 약한 구간은 그린 대로 유지합니다. 결과는 계산 오버레이로 지도에 표시됩니다.",
  "Standard": "표준",
  "Start Using App": "앱 사용 시작",
  "Starting download: {filename}": "다운로드 시작: {filename}",
  "Station names show in Chinese for 廣東話, 繁體中文 and 简体中文; English for others.": "역 이름: 광둥어·번체 중국어·간체 중국어는 중국어, 그 외 언어는 영어로 표시됩니다.",
  "Step {n} of {m}": "{n} / {m} 단계",
  "Stop": "정류장",
  "Stop {n}": "정류장 {n}",
  "Stops on route": "노선 정류장",
  "Sub-page actions": "하위 페이지 작업",
  "Submit failed": "제출 실패",
  "Submit for review": "검토 제출",
  "Submit for review — mods publish after check.": "검토 제출 — 운영자가 확인 후 게시합니다.",
  "Submit method": "제출 방식",
  "Submit successful": "제출 성공",
  "Submitting…": "제출 중…",
  "Swap origin and destination": "출발지와 목적지 바꾸기",
  "Switch branch": "지선 전환",
  "Switch operator": "운송사 전환",
  "Switch branch: {cur} ⇄ {other}": "지선 전환: {cur} ⇄ {other}",
  "Switch Departure": "출발 전환",
  "Switch direction": "방향 전환",
  "Search route": "노선 검색",
  "Search a route first": "먼저 노선을 검색하세요",
  "Search and pick a route first": "먼저 노선을 검색해 선택하세요",
  "Loading directions…": "방면 불러오는 중…",
  "{n} directions on this route": "이 노선은 방면 {n}개",
  "Tap the map to set": "지도를 탭하여 설정",
  "Tap the map to set destination": "지도를 탭하여 목적지 설정",
  "Tap the map to set origin": "지도를 탭하여 출발지 설정",
  "Tap the map to set via": "지도를 탭하여 경유지 설정",
  "Terms": "약관",
  "Terms & Privacy": "약관 및 개인정보",
  "Terms of Service": "서비스 약관",
  "The map's graphics engine keeps failing. Reload the page to try again.": "지도 그래픽 엔진이 계속 실패합니다. 페이지를 다시 로드하세요.",
  "The terms and policies you agreed to when you first set up Travelers.": "처음 Travelers를 설정할 때 동의한 약관과 정책입니다.",
  "The transit data has been refreshed on the server. Re-download the offline set to get the latest routes, stops and fares?": "서버의 교통 데이터가 갱신되었습니다. 최신 노선·정류장·요금을 받으려면 오프라인 세트를 다시 다운로드할까요?",
  "Third-party software, fonts, and data used by Travelers, with license identifiers and attribution links for compliance.": "Travelers가 사용하는 타사 소프트웨어, 글꼴, 데이터 — 규정 준수를 위해 라이선스 식별자와 출처 링크 포함.",
  "Third-party software, fonts, and data used by Travelers, with license identifiers and attribution links for compliance. Last updated 12 Aug 2026 — versions are package ranges; lockfile pins apply at build time. SPDX identifiers as declared upstream; full license text is in each project’s distribution.": "Travelers가 사용하는 타사 소프트웨어, 글꼴, 데이터 — 규정 준수를 위해 라이선스 식별자와 출처 링크 포함. 최종 업데이트 2026년 8월 12일 — 버전은 패키지 범위; 빌드 시 lockfile로 고정. SPDX 식별자는 업스트림 선언 기준; 전체 라이선스 전문은 각 프로젝트 배포본에 포함.",
  "This browser can't render the map — it needs WebGL2 graphics. Update Chrome or Android System WebView and reload.": "이 브라우저는 지도를 렌더링할 수 없습니다 — WebGL2가 필요합니다. Chrome 또는 Android System WebView를 업데이트하고 다시 로드하세요.",
  "This will delete all cached data, preferences, and onboarded state. Are you sure?": "모든 캐시 데이터, 환경설정, 온보딩 상태가 삭제됩니다. 계속하시겠습니까?",
  "Ticket / fare type": "티켓／요금 유형",
  "Ticket type": "티켓 유형",
  "Ticket type used for trip plans and bus boarding prices on route details.": "경로 검색과 노선 상세의 버스 승차 요금에 사용되는 티켓 유형.",
  "Tickets": "티켓",
  "Tile archive format and client loader (Protomaps).": "타일 아카이브 형식과 클라이언트 로더（Protomaps）。",
  "Timetable · {schedN}/{total} routes · {t}": "시간표 · {schedN}/{total}개 노선 · {t}",
  "To": "목적지",
  "To {dest}": "{dest} 방면",
  "Traffic method": "교통수단",
  "Traffic methods": "교통수단",
  "Traffic methods. None selected shows all.": "교통수단. 선택하지 않으면 모두 표시.",
  "Transfer walk": "환승 도보",
  "Transit": "교통",
  "Transit data (Hong Kong)": "교통 데이터（홍콩）",
  "Transport Department open data": "운수서 오픈데이터",
  "Travelers panel": "Travelers 패널",
  "Treated as adult Octopus rates": "성인 옥토퍼스 요금으로 간주",
  "Trip Plan": "경로 검색",
  "Trip Plan · to {name}": "경로 검색 · {name} 방면",
  "Trip detail": "경로 상세",
  "Trip plan pinned": "경로가 고정되었습니다",
  "Trip plan unpinned": "경로 고정이 해제되었습니다",
  "Trip-planning engine (RAPTOR); compiled WASM vendored in this repo (Wheels Labs / Wheels Softworks).": "경로 탐색 엔진（RAPTOR）; 컴파일된 WASM이 이 저장소에 포함（Wheels Labs / Wheels Softworks）。",
  "Try another filter or search term": "다른 필터나 검색어를 시도하세요",
  "Try different locations or a later departure.": "다른 위치나 더 늦은 출발을 시도하세요.",
  "Turning off the banner means you understand and agree that predicted live bus positions are inaccurate and for reference only.": "배너를 숨기면 예측된 실시간 버스 위치가 부정확하며 참고용일 뿐임을 이해하고 동의한 것으로 간주됩니다.",
  "UI icons, loaded from Google Fonts (Google LLC).": "UI 아이콘, Google Fonts에서 로드（Google LLC）。",
  "UI typeface, loaded from Google Fonts (The Montserrat Project Authors).": "UI 글꼴, Google Fonts에서 로드（The Montserrat Project Authors）。",
  "UNLOOP MORGAN Universal Terms of Use for Open-Source Software": "UNLOOP MORGAN 오픈소스 소프트웨어 공통 이용 약관",
  "Undo": "실행 취소",
  "Undo (⌘/Ctrl+Z)": "실행 취소（⌘/Ctrl+Z）",
  "Undo · {n} path pts · {u} undo · {r} redo": "실행 취소 · 경로 점 {n}개 · 실행 취소 {u} · 다시 실행 {r}",
  "Unknown MTR line “{line}”. Try TWL, ISL, KTL, TML, EAL, TCL, TKL, SIL, DRL, or AEL.": "알 수 없는 MTR 노선 \"{line}\"입니다. TWL, ISL, KTL, TML, EAL, TCL, TKL, SIL, DRL, AEL을 시도하세요.",
  "Unpin": "고정 해제",
  "Unpin plan": "핀 해제",
  "Unpin stop": "핀 해제",
  "Unpin this trip": "이 경로 고정 해제",
  "Unpinned {id}": "{id} 고정 해제됨",
  "Update available": "업데이트가 있습니다",
  "Update data": "데이터 업데이트",
  "Update frequency": "업데이트 주기",
  "Update now": "지금 업데이트",
  "Updated —": "업데이트됨 —",
  "Updated {n}h ago": "{n}시간 전 업데이트",
  "Updated {n}m ago": "{n}분 전 업데이트",
  "Updated {n}s ago": "{n}초 전 업데이트",
  "Uploading path for review": "검토용 경로 업로드 중",
  "Use current location": "현재 위치 사용",
  "Use current location as origin": "현재 위치를 출발지로 사용",
  "Use Resident Fare on RBS": "RBS에서 주민 요금 사용",
  "Usual": "평일",
  "Usual uses weekday timetables; Holiday uses Sunday / public-holiday service.": "평일은 월~금 시간표 사용; 공휴일은 일요일／공휴일 운행 시간표 사용.",
  "V path · S visual stops · R follow roads · Tab switch. Official greys stay fixed.": "V 경로 · S 시각적 정류장 · R 도로 추종 · Tab 전환. 공식 회색은 고정 유지.",
  "Vector basemap": "벡터 베이스맵",
  "Vertex kept raw (OSRM weak)": "정점 원본 유지（OSRM 약함）",
  "Vertex snapped to road": "정점이 도로에 스냅됨",
  "Visit your PR": "PR 열기",
  "Visit {visitN} of {visitTotal} on this route": "이 노선 {visitTotal}회 중 {visitN}회째",
  "Visual stop pins (S) — official stays fixed": "시각적 정류장 핀（S）— 공식 정류장은 고정",
  "Visual stops": "시각적 정류장",
  "Visual stops mode (S)": "시각적 정류장 모드 (S)",
  "Visual stops mode (S) — drag orange pins": "시각적 정류장 모드 (S) — 주황색 핀 드래그",
  "Visual stops re-projected onto path · official coords still fixed": "시각적 정류장을 경로에 재투영했습니다 · 공식 좌표는 고정 유지",
  "Visual stops snapped to path (official unchanged)": "시각적 정류장을 경로에 스냅했습니다(공식 위치는 변경 없음)",
  "Visual stops: no stops loaded — Load calculated path first": "시각적 정류장: 정류장이 로드되지 않았습니다 — 먼저 계산된 경로를 로드하세요",
  "Visual stops: {n} orange pins · grey ghost only if moved from official · drag to adjust": "시각적 정류장: 주황색 핀 {n}개 · 공식 위치에서 이동한 경우에만 회색 고스트 · 드래그로 조정",
  "Via": "경유",
  "Via {n}": "경유 {n}",
  "Via cleared": "경유를 지웠습니다",
  "Via is the same as the destination": "경유지가 목적지와 같습니다",
  "Via is the same as the origin": "경유지가 출발지와 같습니다",
  "Via suggestions": "경유지 제안",
  "Walk": "도보",
  "Walk to {dest}": "{dest}까지 도보",
  "Walk to {to}": "{to}까지 도보",
  "Walk to destination": "목적지까지 도보",
  "Walk to station": "역까지 도보",
  "Walk the free link to {place}": "무료 연결 통로로 {place}까지 도보",
  "Welcome to MORGAN Travelers": "MORGAN Travelers에 오신 것을 환영합니다",
  "Welcome!": "환영합니다!",
  "Yes, cache all data": "예, 모든 데이터를 캐시합니다",
  "You were running on downloaded data. Restart to load the latest data from the cloud.": "다운로드한 데이터로 실행 중이었습니다. 다시 시작하면 클라우드의 최신 데이터를 불러옵니다.",
  "Your name (optional)": "이름（선택 사항）",
  "You can add up to {n} vias": "경유지는 최대 {n}개까지 추가할 수 있습니다",
  "Your path was saved to the review queue.": "경로가 검토 대기열에 저장되었습니다.",
  "Your path was submitted and a pull request was opened from your GitHub account.": "경로가 제출되었고 GitHub 계정에서 풀 리퀘스트가 열렸습니다.",
  "Your path was submitted and a review pull request was opened by the site bot.": "경로가 제출되었고 검토 풀 리퀘스트가 사이트 봇에 의해 열렸습니다.",
  "Your path was submitted for review.": "경로가 검토용으로 제출되었습니다.",
  "another route": "다른 노선",
  "as {author}": "{author}(으)로",
  "auto after load": "로드 후 자동",
  "cycle": "전환",
  "default": "기본",
  "desktop": "데스크톱",
  "e.g. Central Station · @MTR @LRT @Bus": "예: 센트럴 역 · @MTR @경전철 @버스",
  "e.g. Yuen Long Station": "예: 위안롱 역",
  "e.g. Times Square · meet here": "예: 타임스 스퀘어 · 여기서 만나기",
  "e.g. via Mei Tung Street, not terminus bay": "예: 터미널 승강장이 아닌 메이퉁 가 경유",
  "filters.": "필터.",
  "fork (credited to you).": "포크에서 PR 열기(귀하의 기여로 인정됨).",
  "id {id}": "id {id}",
  "min": "분",
  "multi-select": "다중 선택",
  "on this panel).": "이 패널에 놓기).",
  "path ·": "경로 ·",
  "published path that covers the same corridor; otherwise live OSRM.": "같은 구간을 다루는 게시된 경로; 없으면 실시간 OSRM.",
  "roads ·": "도로 ·",
  "route {r}": "{r} 노선",
  "select ·": "선택 ·",
  "similar": "유사한",
  "stops ·": "정류장 ·",
  "to discard.": "버리려면.",
  "to keep,": "유지하려면,",
  "visual stop pins": "시각적 정류장 핀",
  "{base} - Platform {p}": "{base} - {p}번 승강장",
  "{h} h": "{h}시간",
  "{h} h {m} min": "{h}시간 {m}분",
  "{kindLabel} {routeId} → {dest}": "{kindLabel} {routeId} → {dest} 방면",
  "{n} min": "{n}분",
  "1 min": "1분",
  "your": "내",
  "{n} offset points selected": "오프셋 점 {n}개 선택됨",
  "{n} path points on map (stop names unavailable).": "지도에 경로점 {n}개（정류장 이름 없음）。",
  "{n} pinned route{s}": "고정 정류장 {n}개{s}",
  "{n} pinned stop{s}": "고정 정류장 {n}개{s}",
  "{n} plan(s) · {ms} ms": "경로 {n}개 · {ms}ms",
  "{n} plan(s) via {place} · {ms} ms": "{place} 경유 경로 {n}개 · {ms}ms",
  "{n} points selected": "{n}개 점 선택됨",
  "{n} points selected · Delete/Backspace to remove · Shift+drag to add": "{n}개 점 선택됨 · Delete/Backspace로 제거 · Shift+드래그로 추가",
  "{n} stops": "정류장 {n}개",
  "{n}m": "{n}분",
  "{pts} pts": "{pts}개 점",
  "· green rings = path · orange = visual stop · grey = official fixed": "· 녹색 링 = 경로 · 주황색 = 시각적 정류장 · 회색 = 공식 고정",
};